import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { MatDialog } from '@angular/material';
import { Ng2DeviceService } from 'ng2-device-detector';
import { ConfigurationService } from '../services/configuration.service';
import { RequisitionService } from '../services/requisition.service';
import { ContractRequisition } from '../models/contractRequisition';
import { Requisition } from '../models/requisition';
import { JobTypeService } from '../services/jobtype.service';
import { EnterpriseService } from '../services/enterprise.service';

@Component({
  selector: 'app-form-requisition',
  templateUrl: './form-requisition.component.html',
  styleUrls: ['./form-requisition.component.css']
})
export class FormRequisitionComponent implements OnInit {

  @Input() requisitionEditId: string;
  @Input() disabled: boolean;
  @Input() viewCompany: boolean;
  public publicating: boolean;
  public contractRequisition: ContractRequisition;

  public isLinear;
  public firstFormGroup: FormGroup;
  public secondFormGroup: FormGroup;
  public thirdFormGroups: FormGroup[];

  deviceInfo = null;
  chrome_version = '56.0.2924';
  safari_version = '10.0.3';
  explorer_version = '10.0';
  firefox_version = '45.7.0esr';
  browser_version: string;
  errorConnection: boolean;
  noBrowserSupported: string;

  jobType: any;
  errorMessage: string;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private deviceService: Ng2DeviceService,
    private configurationService: ConfigurationService,
    private requisitionService: RequisitionService,
    private jobTypeService: JobTypeService,
    private enterpriseService: EnterpriseService
  ) { }

  emailRegex: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  ngOnInit() {
    this.getJobType();
    this.publicating = false;
    this.isLinear = false;

    this.firstFormGroup = this.fb.group({
      legalname: [{value: '', disabled: this.disabled}, Validators.required],
      nit: [{value: '', disabled: this.disabled}, Validators.required],
      legalrep_name: [{value: '', disabled: this.disabled}, Validators.required],
      email: [{value: '', disabled: this.disabled}, Validators.email],
      phone: [{value: '', disabled: this.disabled}, Validators.required],
      // web: [{value: '', disabled: this.disabled}, Validators.required],
       //country: [{value: '', disabled: this.disabled}, Validators.required],
      // city: [{value: '', disabled: this.disabled}, Validators.required],
      // address: [{value: '', disabled: this.disabled}, Validators.required],
      // location: [{value: '', disabled: this.disabled}, Validators.required],
      // industry: [{value: '', disabled: this.disabled}, Validators.required],

      // services: [{value: '', disabled: this.disabled}, Validators.required],
      // clients: [{value: '', disabled: this.disabled}, Validators.required],
      // moreinfo: [{value: '', disabled: this.disabled}, Validators.required],

    });

    this.secondFormGroup = this.fb.group({
      contact_name: [{value: '', disabled: this.disabled}, Validators.required],
      contact_phone: [{value: '', disabled: this.disabled}, Validators.required],
      contact_email: [{value: '', disabled: this.disabled}, Validators.required],
    });

    this.thirdFormGroups = [];
    this.contractRequisition = new ContractRequisition();
    if (this.requisitionEditId) {
      this.initContractRequisiton(this.requisitionEditId);
    } else {
      this.initContractRequisiton();
    }

    this.deviceInfo = this.deviceService.getDeviceInfo();
    if (this.deviceInfo.browser === 'chrome') {
      this.browser_version = this.chrome_version;
    } else if (this.deviceInfo.browser === 'safari') {
      this.browser_version = this.safari_version;
    } else if (this.deviceInfo.browser === 'ie') {
      this.browser_version = this.explorer_version;
    } else if (this.deviceInfo.browser === 'firefox') {
      this.browser_version = this.firefox_version;
    } else {
      this.browser_version = '';
    }

    if (this.browser_version !== '') {
      const options = {lexicographical: true, zeroExtend: true};
      const compare = this.versionCompare(this.deviceInfo.browser_version, this.browser_version, options);
      if (compare < 0) {
        this.noBrowserSupported = 'true';
      } else {
        this.noBrowserSupported = 'false';
      }
    } else {
      this.noBrowserSupported = 'true';
    }

    this.configurationService.errorHttp$.subscribe(
      response => {
        if (response) {
          this.errorConnection = true;
        } else {
          this.errorConnection = false;
        }
      }
    );
  }

  initContractRequisiton(requisition?) {
    if (requisition) {
      this.requisitionService.getRequisition(requisition)
      .subscribe(
        res => {
          this.contractRequisition.legalname = res.contract.company.legalname;
          this.contractRequisition.nit = res.contract.company.nit;
          //this.contractRequisition.country = res.contract.company.legal_country;
          // this.contractRequisition.city = res.contract.company.legal_city;
          // this.contractRequisition.address = res.contract.company.address;
          // this.contractRequisition.location = res.contract.company.location;
          // this.contractRequisition.industry = res.contract.company.industry;
          this.contractRequisition.email = res.contract.company.email;
          this.contractRequisition.phone = res.contract.company.phone;
          this.contractRequisition.contact_email = res.contact_email,
          this.contractRequisition.contact_phone = res.contact_phone,
          this.contractRequisition.contact_name = res.contact_name,
          // this.contractRequisition.web = res.contract.company.web;
          // this.contractRequisition.services = res.contract.company.services;
          // this.contractRequisition.clients = res.contract.company.clients;
          // this.contractRequisition.moreinfo = res.contract.company.moreinfo;
          this.contractRequisition.legalrep_name = res.contract.company.contact;
          // this.contractRequisition.legalrep_idtype = res.contract.company.legalrep_idtype;
          // this.contractRequisition.legalrep_idnumber = res.contract.company.legalrep_idnumber;
          this.initThirdFormGroups();
          this.addRequisition(res);
        },
        () => {
          console.log('Error retrieving Requisition');
        }
      );
    } else {
      this.contractRequisition = {
        id: undefined,
        contract_id: undefined,
        company_id: undefined,
        legalname: undefined,
        nit: undefined,
        email: undefined,
        phone: undefined,
        contact_email: undefined,
        contact_phone: undefined,
        contact_name: undefined,
        // name: undefined,
        // contact: undefined,

        // address: undefined,
        // city: undefined,
        // country: undefined,
        // location: undefined,

        // web: undefined,
        // industry: undefined,
        legalrep_name: undefined,
        // legalrep_idtype: undefined,
        // legalrep_idnumber: undefined,
        // company_infocol: undefined,

        // taxid: undefined,
        // legal_address: undefined,
        // legal_city: undefined,
        // legal_country: undefined,
        // industry_id: undefined,
        // services: undefined,
        // clients: undefined,
        // moreinfo: undefined,
        // amount: undefined,
        requisitions: []
      };
      this.addRequisition();
    }
  }

  getCompany() {
    console.log('search:' + this.contractRequisition.nit);
    this.enterpriseService.getEnterpriseByNit(this.contractRequisition.nit)
    .subscribe(
      res => {
        console.log(res);
        this.contractRequisition.company_id = res.id;
        this.contractRequisition.legalname = res.name;
        this.contractRequisition.legalrep_name = res.contact;
        this.contractRequisition.email = res.email;
        this.contractRequisition.phone = res.telephone;
      },
      () => {
        console.log('Error retrieving EnterpriseByNit');
      }
    );
  }

  addRequisition(requisition?) {
    if (requisition) {
      this.contractRequisition.requisitions = [];
      this.contractRequisition.requisitions.push({
        id: requisition.id,
        contract_id: requisition.contract_id,
        position_name: requisition.position_name,
        vacancies: requisition.vacancies,
        salary: requisition.salary,
        jobtype_id: requisition.jobtype_id,
        working_days_hours: requisition.working_days_hours,
        job: requisition.job,
        assigned_freelancers: requisition.assigned_freelancers,
        qa: requisition.qa,
        description: requisition.description,
        more_info: requisition.more_info,
        address: requisition.address,
        notes: requisition.notes
      });
    } else {
      this.contractRequisition.requisitions.push({
        id: undefined,
        contract_id: undefined,
        // notes: undefined,
        position_name: undefined,
        vacancies: undefined,
        description: undefined,
        salary: undefined,
        address: undefined,
        jobtype_id: undefined,
        working_days_hours: undefined,
        job: undefined,
        assigned_freelancers: undefined,
        qa: undefined,
        more_info: undefined,
        notes: undefined
      });
      this.initThirdFormGroups();
    }
    console.log(this.contractRequisition);
  }

  public initThirdFormGroups() {
    this.thirdFormGroups.push(this.fb.group({
      // notes: [{value: ''}, Validators.required],
      position_name: [{value: ''}, Validators.required],
      description: [{value: ''}, Validators.required],
      vacancies: [{value: ''}, Validators.required],
      salary: [{value: ''}, Validators.required],
      jobtype_id: [{value: ''}, Validators.required],
      working_days_hours: [{value: ''}, Validators.required],
      address: [{value: ''}, Validators.required],
      more_info: [{value: ''}, Validators.required],
      // department: [{value: ''}, Validators.required],
      // manager: [{value: ''}, Validators.required],
      // team: [{value: ''}, Validators.required],
      // personal_in_charge: [{value: ''}, Validators.required],
      // salary_noshow: [{value: ''}, Validators.required],
      // salary_additional: [{value: ''}, Validators.required],
      // commissions: [{value: ''}, Validators.required],
      // gender: [{value: ''}, Validators.required],
      // gender_desirable: [{value: ''}, Validators.required],
      // age_range: [{value: ''}, Validators.required],
      // experience_years: [{value: ''}, Validators.required],
      // experience_years_desirable: [{value: ''}, Validators.required],
      // functions: [{value: ''}, Validators.required],
      // skills: [{value: ''}, Validators.required],
      // skills_desirable: [{value: ''}, Validators.required],
      // knowledge: [{value: ''}, Validators.required],
      // knowledge_desirable: [{value: ''}, Validators.required],
      // academic_background: [{value: ''}, Validators.required],
      // academic_background_desirable: [{value: ''}, Validators.required],
      // responsibilities: [{value: ''}, Validators.required],
      // languages: [{value: ''}, Validators.required],
      // languages_desirable: [{value: ''}, Validators.required],
      // software: [{value: ''}, Validators.required],
      // software_desirable: [{value: ''}, Validators.required],
      // relevant_aspects: [{value: ''}, Validators.required],
      // relevant_aspects_desirable: [{value: ''}, Validators.required],
      // competences: [{value: ''}, Validators.required],
    }));
  }

  onPostRequisition() {    
    this.requisitionService.postRequisition(this.contractRequisition)
    .subscribe(
      data => {
        this.publicating = false;
        this.dialog.open(MessageBoxDialog, {data: {message: 'Requisición Creada', success: true, showIcon: true}});

        this.firstFormGroup.reset();
        this.secondFormGroup.reset();
    
        if (this.thirdFormGroups.length > 1) {
          this.thirdFormGroups.splice(1, this.thirdFormGroups.length);
          this.contractRequisition.requisitions.splice(1, this.thirdFormGroups.length);
        }
        this.thirdFormGroups[0].reset();
    
        console.log(this.thirdFormGroups);
        console.log(this.contractRequisition);
      },
      error => {
        console.log(error);
        this.dialog.open(MessageBoxDialog, {data: {title: 'No se pudo crear la Requisición',
          message: 'Verifique los datos: ' + error, alert: true, showIcon: true}});
        this.publicating = false;
       }
    );
  }

  onPutRequisition() {
    this.requisitionService.putRequisition(this.contractRequisition.requisitions[0])
    .subscribe(
      data => {
        this.publicating = false;
        this.dialog.open(MessageBoxDialog, {data: {message: 'Requisición Actualizada', success: true, showIcon: true}});
      },
      error => {
        console.log(error);
        this.dialog.open(MessageBoxDialog, {data: {title: 'No se pudo actualizar la Requisición',
          message: 'Verifique los datos: ' + error, alert: true, showIcon: true}});
        this.publicating = false;
       }
    );
  }
  
  getJobType() {
    this.jobTypeService.getJobType()
    .subscribe(
      data => {
        this.jobType = data;
      },
      error => this.errorMessage = <any>error
    );
  }

  getValueKey (obj,key) {
    for (let i = 0; i < obj.length; ++i) {
      if (obj[i].id === key) {
        return obj[i].name;
      }
    }
    return '';
  }


 /**
 * Compares two software version numbers (e.g. "1.7.1" or "1.2b").
 *
 * This function was born in http://stackoverflow.com/a/6832721.
 *
 * @param {string} v1 The first version to be compared.
 * @param {string} v2 The second version to be compared.
 * @param {object} [options] Optional flags that affect comparison behavior:
 * <ul>
 *     <li>
 *         <tt>lexicographical: true</tt> compares each part of the version strings lexicographically instead of
 *         naturally; this allows suffixes such as "b" or "dev" but will cause "1.10" to be considered smaller than
 *         "1.2".
 *     </li>
 *     <li>
 *         <tt>zeroExtend: true</tt> changes the result if one version string has less parts than the other. In
 *         this case the shorter string will be padded with "zero" parts instead of being considered smaller.
 *     </li>
 * </ul>
 * @returns {number|NaN}
 * <ul>
 *    <li>0 if the versions are equal</li>
 *    <li>a negative integer iff v1 < v2</li>
 *    <li>a positive integer iff v1 > v2</li>
 *    <li>NaN if either version string is in the wrong format</li>
 * </ul>
 *
 * @copyright by Jon Papaioannou (["john", "papaioannou"].join(".") + "@gmail.com")
 * @license This function is in the public domain. Do what you want with it, no strings attached.
 */
versionCompare(v1, v2, options) {
  const lexicographical = options && options.lexicographical,
      zeroExtend = options && options.zeroExtend;
  let v1parts = v1.split('.'),
      v2parts = v2.split('.');

  function isValidPart(x) {
      return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
  }

  if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
      return NaN;
  }

  if (zeroExtend) {
      while (v1parts.length < v2parts.length) { v1parts.push('0'); }
      while (v2parts.length < v1parts.length) { v2parts.push('0'); }
  }

  if (!lexicographical) {
      v1parts = v1parts.map(Number);
      v2parts = v2parts.map(Number);
  }

  for (let i = 0; i < v1parts.length; ++i) {
      if (v2parts.length === i) {
        return 1;
      }

      if (Number(v1parts[i]) === Number(v2parts[i])) {
        continue;
      } else if (Number(v1parts[i]) > Number(v2parts[i])) {
        return 1;
      } else {
        return -1;
      }
  }

  if (v1parts.length !== v2parts.length) {
      return -1;
  }

  return 0;
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/form-requisition/form-requisition.component.ts